export const classes = [
    {
        name: 'dubai',
        class: 'compact-wrapper'
    },
    {
        name: 'london',
        class: 'only-body'
    },
    {
        name: 'seoul',
        class: 'compact-wrapper modern-type'
    },
    {
        name: 'losangeles',
        class: 'horizontal-wrapper material-type'
    },
    {
        name: 'paris',
        class: 'compact-wrapper dark-sidebar'
    },
    {
        name: 'tokyo',
        class: 'compact-sidebar'
    },
    {
        name: 'madrid',
        class: 'compact-wrapper color-sidebar'
    },
    {
        name: 'moscow',
        class: 'compact-sidebar compact-small'
    },
    {
        name: 'newyork',
        class: 'compact-wrapper box-layout'
    },
    {
        name: 'singapore',
        class: 'horizontal-wrapper enterprice-type'
    },
    {
        name: 'rome',
        class: 'compact-sidebar compact-small material-icon'
    },
    {
        name: 'barcelona',
        class: 'horizontal-wrapper enterprice-type advance-layout'
    }
];